import styled from "styled-components";
import {Link} from "react-router-dom"

const Boton = styled(Link)`
    background: ${(props) => props.primario ? '#fbd000' : '#E9ECF3'};
    width: ${(props) => props.conIcono ? '15.62rem' : 'auto'}; /* 250px */
    margin-left: 1.25rem; /* 20px */
    border: 1px solid rgba(0, 0, 0, 0.2);
    border-radius: 0.3rem;
    color: #0F265C;
    font-family: 'Work Sans', sans-serif;
    height: 3rem; /* 60px */
    padding: 1rem 1.62rem; /* 20px 30px */
    font-size: 1rem; /* 20px */
    font-weight: 500;
    cursor: pointer;
    text-decoration: none;
    display: inline-flex;
    justify-content: space-between;
    align-items: center;
    outline: none;
 
    svg {
        height: ${(props) => props.iconoGrande ? '100%' : '0.75rem;'};  /* 12px */
        fill: white;
    }
`;

export default Boton;